import { render, staticRenderFns } from "./RedemptionReasons.vue?vue&type=template&id=057b849a&scoped=true"
import script from "./RedemptionReasons.vue?vue&type=script&lang=js"
export * from "./RedemptionReasons.vue?vue&type=script&lang=js"
import style0 from "./RedemptionReasons.vue?vue&type=style&index=0&id=057b849a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b849a",
  null
  
)

export default component.exports